<template>
  <loading v-if="loading"></loading>
  <div class="contain" v-else>
    <div class="contain-big1">
      <div class="contain-big-left">
        <div class="contain-big-left-box">
          <div class="contain-big-left-box-details">课程详情</div>
          <!-- 课程标题 -->
          <div class="contain-big-left-box-title">
            <div>课程</div>
            <span>{{ details.other_course.name }}</span>
          </div>
          <!-- 课程内容 -->
          <div class="contain-big-left-box-content">{{ richTextFormat }}</div>
          <!-- 课程地址 -->
          <div class="contain-big-left-box-address">
            <img src="../../assets/image/blueAddress.png" alt="" />
            <span>上课地点：{{ details.classroom.name }}</span>
          </div>
          <!-- 学期 -->
          <div class="contain-list-box-time">
            <div class="contain-list-box-time-left">
              <div>
                {{ details.start_school_year }}-{{
                  details.end_school_year
                }}年度
              </div>
              <div>{{ details.semester == 1 ? "第一学期" : "第二学期" }}</div>
            </div>
            <div class="contain-list-box-time-right">
              <img src="../../assets/image/class_hour.png" alt="" />
              <span>共{{ details.other_course.total_class_hour }}课时</span>
            </div>
          </div>
          <!-- 培训时间 -->
          <div class="contain-big-left-box-time">
            <span>技能培训1时间：</span>
            <div class="contain-big-left-box-time-box">
              <img src="../../assets/image/date.png" alt="" />
              <span
                >{{ startTime }}月{{ timeList[0].time }}日 至 {{ endTime }}月{{
                  timeList[6].time
                }}日</span
              >
            </div>
          </div>
          <!-- 每周培训时间 -->
          <div class="contain-big-left-box-week">
            <div class="header">
              <!-- :style="{ color: todayWeekIndex === index ? '#4070FF' : 'unset' }" -->
              <div
                class="header-item"
                v-for="(item, index) in timeList"
                :key="index"
                :class="
                  active === index ? 'click' : item.active ? 'active' : ''
                "
                @click="clickWeek(index)"
              >
                <div class="">{{ item.week }}</div>
                <div class="">{{ item.time }}</div>
              </div>
            </div>
          </div>
          <!-- 每周具体培训时间 -->
          <div
            class="contain-big-left-box-weekTime"
            v-if="courseTime.length > 0"
          >
            <div
              class="contain-big-left-box-weekTime-box"
              v-for="(item1, index1) in courseTime"
              :key="index1"
            >
              <div class="contain-big-left-box-weekTime-box-circular"></div>
              <div class="contain-big-left-box-weekTime-box-time">
                {{ item1.start_at.substring(0, 5) }} -
                {{ item1.end_at.substring(0, 5) }}
              </div>
            </div>
          </div>
          <div class="contain-big-left-box-weekTime" v-else>
            <div class="contain-big-left-box-weekTime-noData">今天暂无课程</div>
          </div>
          <!-- 售价 -->
          <div class="contain-big-left-box-price">
            <div class="contain-big-left-box-price-title">售价：</div>
            <div class="contain-big-left-box-price-num">
              <span>￥</span><span>{{ details.other_course.price }}</span>
            </div>
          </div>
          <!-- 按钮 -->
          <div
            class="contain-big-left-box-btn"
            v-if="details.is_enroll == 0"
            @click="createOrder(details.id)"
          >
            立即报名
          </div>
          <div class="contain-big-left-box-btn gary" v-else>已报名</div>
        </div>
      </div>
      <div class="contain-big-right">
        <div class="contain-big-right-box">
          <div class="contain-big-right-title">课程介绍</div>
          <div class="contain-big-right-content">
            <p v-html="details.other_course.details"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付弹窗 -->
    <el-dialog
      custom-class="dialog"
      :visible.sync="isPay"
      :show-close="false"
      width="27%"
      center
    >
      <div class="pay">
        <div class="content" v-loading="codeLoading">
          <div class="content-left">
            <img :src="code" alt="" />
            <div class="content-left-msg">
              <img src="../../assets/image/sao.png" alt="" />
              <div>打开手机微信使用扫一扫继续付款</div>
            </div>
          </div>
          <div class="content-right">
            <img src="../../assets/image/wei_sao.png" alt="" />
            <div class="content-right-msg">
              <div>扫一扫付款（元）</div>
              <div>{{ details.other_course.price }}</div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="okPay">已支付</el-button>
          <el-button @click="isPay = false">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import loading from "@/components/loading/loading.vue";
import request from "@/utils/request";
import { formatDayTime } from "../../utils/common.js";
const oneDayTimeStamp = 86400000; // 一天的时间戳
const now = new Date();
const todayDayTimeStamp = now.getTime(); //今天的时间戳
const day = now.getDay();
const getDay = day === 0 ? 7 : day; // 今天的星期
export default {
  components: { loading },
  data() {
    return {
      isPay: false,
      active: 0,
      loading: true,
      timeList: [
        {
          time: "1",
          week: "周一",
          weekIndex: 1,
          active: false,
        },
        {
          time: "2",
          week: "周二",
          weekIndex: 2,
          active: false,
        },
        {
          time: "3",
          week: "周三",
          weekIndex: 3,
          active: false,
        },
        {
          time: "4",
          week: "周四",
          weekIndex: 4,
          active: false,
        },
        {
          time: "5",
          week: "周五",
          weekIndex: 5,
          active: false,
        },
        {
          time: "6",
          week: "周六",
          weekIndex: 6,
          active: false,
        },
        {
          time: "7",
          week: "周日",
          weekIndex: 0,
          active: false,
        },
      ],
      week: getDay, // 今天的星期
      num: 0, // 记录周数，下一周加一，上一周减一, 0:本周
      time: now.toISOString().slice(0, 10),
      mondayDayTimeStamp: 0, // 星期一的时间戳
      sundayDayTimeStamp: 0, // 星期天的时间戳,
      details: null,
      courseTime: [],
      code: "",
      codeLoading: true,
    };
  },
  computed: {
    richTextFormat() {
      let value = this.details.other_course.details;
      value = value.replace(/<\/?.+?>/g, "");
      value = value.replace(/\s+/g, "");
      if (value.length > 90) {
        return value.slice(0, 90) + "...";
      }
      return value;
    },
    // 开始日期
    startTime() {
      return new Date(this.mondayDayTimeStamp).getMonth() + 1; //月份
    },
    // 结束日期
    endTime() {
      return new Date(this.sundayDayTimeStamp).getMonth() + 1; //月份
    },
    // 当前天数的索引
    todayWeekIndex() {
      let weekIndex = new Date().getDay() - 1;
      if (weekIndex === -1) {
        weekIndex = 6;
      }
      return weekIndex;
    },
  },
  created() {
    this.thisWeek(); // 一开始进入页面获取本周的课程表
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    okPay() {
      this.isPay = false;
      this.getDetails();
    },
    setPay(order_no) {
      this.codeLoading = true;
      request({
        url: "/api/userend/pay",
        method: "post",
        params: { order_no: order_no, pay_type: 2 },
      }).then((response) => {
        if (response.code == 0) {
          this.code = response.data;
          this.codeLoading = false;
        }
        // this.isOKPay(order_no)
      });
    },
    isOKPay(order_no) {
      request({
        url: "/api/userend/orderStatus",
        method: "get",
        params: { order_no: order_no },
      }).then((response) => {
        if (response.data.pay_status != 1) {
          this.isPay = false;
        }
      });
    },
    // 切换日期
    clickWeek(index) {
      this.active = index;
      this.courseTime = this.details.schedule.filter((item) => {
        return item.week_index == this.timeList[index].weekIndex;
      });
    },
    //报名
    createOrder(id) {
      request({
        url: "/api/userend/otherCourse/createOrder",
        method: "post",
        params: { other_course_school_id: id },
      }).then((response) => {
        this.isPay = true;
        this.setPay(response.data);
        // const { href } = this.$router.resolve({
        // path: '/pay',
        // query: {
        //     order_no:response.data
        // }
        // });
        // window.open(href, '_blank');
      });
    },
    //课程详情
    getDetails() {
      this.loading = true;
      request({
        url: "/api/userend/otherCourse/detail",
        method: "get",
        params: { id: this.$route.query.id },
      }).then((response) => {
        this.details = response.data;
        this.loading = false;
        this.timeList.forEach((item) => {
          response.data.schedule.forEach((item1) => {
            if (item.weekIndex == item1.week_index) {
              item.active = true;
            }
          });
        });
        this.clickWeek(this.todayWeekIndex); //获取当天的课程时间
      });
    },
    thisWeek() {
      console.log("本周");
      this.mondayDayTimeStamp =
        todayDayTimeStamp - oneDayTimeStamp * (getDay - 1); // 星期一的时间戳
      this.sundayDayTimeStamp =
        (7 - getDay) * oneDayTimeStamp + todayDayTimeStamp; //星期天的时间戳
      this.dayList();
    },
    dayList() {
      // 获取本周日期
      for (let i = 0; i < 7; i++) {
        if (this.num === 0) {
          i + 1 === getDay
            ? (this.timeList[i].time = +formatDayTime(
                this.mondayDayTimeStamp + i * oneDayTimeStamp
              ).substring(8))
            : (this.timeList[i].time = +formatDayTime(
                this.mondayDayTimeStamp + i * oneDayTimeStamp
              ).substring(8));
        } else {
          this.timeList[i].time = +formatDayTime(
            this.mondayDayTimeStamp + i * oneDayTimeStamp
          ).substring(8);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contain {
  .pay {
    .dialog-footer {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0 80px;
      .el-button {
        width: 130px;
        height: 49px;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        // color: #1875FF;
      }
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      .content-left {
        padding: 5px 5px 15px 5px;
        width: 49%;
        background: #ffffff;
        border: 1px solid #f8f8f8;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 214px;
          height: 214px;
        }
        .content-left-msg {
          margin-top: 15px;
          padding: 0 12px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          img {
            width: 35px;
            height: 35px;
          }
          div {
            margin-left: 8px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 25px;
          }
        }
      }
      .content-right {
        width: 49%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 205px;
          height: 182px;
        }
        .content-right-msg {
          margin-top: 34px;
          div {
            &:nth-child(1) {
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
            &:nth-child(2) {
              margin: 10px 0;
              font-size: 28px;
              font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
              font-weight: bold;
              color: #e63838;
              line-height: 37px;
            }
          }
        }
      }
    }
  }
  .contain-big1 {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .contain-big-left {
      position: fixed;
      left: 120px;
      width: 35%;
      .contain-big-left-box {
        padding: 25px;
        background: #ffffff;
        border-radius: 8px;
        .contain-big-left-box-details {
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1e2134;
          padding-bottom: 15px;
          border-bottom: 1px solid #f9fafd;
        }
        .contain-big-left-box-title {
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          div {
            text-align: center;
            width: 38px;
            height: 19px;
            background: #3d7eff;
            border-radius: 11px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 19px;
          }
          span {
            margin-left: 5px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1e2134;
          }
        }
        .contain-big-left-box-content {
          margin-top: 10px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #757575;
          line-height: 22px;
          img {
            max-width: 100% !important;
            height: auto !important;
          }
        }
        .contain-big-left-box-address {
          margin-top: 15px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          img {
            width: 14px;
            height: 14px;
          }
          span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2134;
            margin-left: 5px;
          }
        }
        .contain-list-box-time {
          margin-top: 15px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 15px 0;
          border-top: solid 1px #f9fafd;
          border-bottom: solid 1px #f9fafd;
          .contain-list-box-time-left {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            div {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              &:nth-child(2) {
                margin-left: 6px;
              }
            }
          }
          .contain-list-box-time-right {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            img {
              width: 18px;
              height: 18px;
            }
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #3d7eff;
              margin-left: 5px;
            }
          }
        }
        .contain-big-left-box-time {
          margin-top: 15px;
          span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2134;
          }
          .contain-big-left-box-time-box {
            margin-top: 17px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            img {
              width: 34px;
              height: 34px;
            }
            span {
              font-size: 22px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1e2134;
              margin-left: 5px;
            }
          }
        }
        .contain-big-left-box-week {
          margin-top: 15px;
          padding: 20px 0;
          border-top: 1px solid #f9fafd;
          border-bottom: 1px solid #f9fafd;
          .header {
            width: 100%;
            padding: 0 5px;
            padding-left: 0px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            background: #ffffff;
            .header-item {
              cursor: pointer;
              width: 13%;
              padding: 5px 0;
              // flex: 1;
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 32px;
            }
            .active {
              padding: 8px 0;
              background: #eaf1fe;
              border-radius: 6px;
              opacity: 1;
              border-radius: 12px;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #3d7eff;
            }
            .click {
              padding: 8px 0;
              background: #3d7eff;
              border-radius: 6px;
              opacity: 1;
              border-radius: 12px;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #ffffff;
            }
          }
        }
        .contain-big-left-box-weekTime {
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          .contain-big-left-box-weekTime-noData {
            padding: 15px 0;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1e2134;
          }
          .contain-big-left-box-weekTime-box {
            width: 30%;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
            padding: 15px 0;
            // border: springgreen 1px solid;
            .contain-big-left-box-weekTime-box-circular {
              width: 10px;
              height: 10px;
              background: #3d7eff;
              border-radius: 50%;
              margin-right: 4px;
            }
            .contain-big-left-box-weekTime-box-time {
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1e2134;
              margin-left: 4px;
            }
          }
        }
        .contain-big-left-box-price {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0;
          border-top: 1px solid #f9fafd;
          border-bottom: 1px solid #f9fafd;
          .contain-big-left-box-price-title {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2134;
          }
          .contain-big-left-box-price-num {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            span {
              &:nth-child(1) {
                font-size: 16px;
                font-family: SFProDisplay-Semibold, SFProDisplay;
                font-weight: 600;
                color: #f24342;
                margin-top: 3px;
              }
              &:nth-child(2) {
                font-size: 20px;
                font-family: SFProDisplay-Semibold, SFProDisplay;
                font-weight: 600;
                color: #f24342;
              }
            }
          }
        }
        .contain-big-left-box-btn {
          cursor: pointer;
          text-align: center;
          width: 315px;
          height: 50px;
          margin: 0 auto;
          background: #3d7eff;
          border-radius: 6px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 50px;
          margin-top: 110px;
        }
        .gary {
          background: #cccccc;
        }
      }
    }
    .contain-big-right {
      width: 60%;
      .contain-big-right-box {
        padding: 25px;
        background: #ffffff;
        border-radius: 8px;
        .contain-big-right-title {
          padding-bottom: 15px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1e2134;
          border-bottom: solid 1px #f9fafd;
        }
        .contain-big-right-content {
          margin-top: 20px;
          p {
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>